export default __webpack_public_path__ + "static/lobbyists_codebook-8f8454a3213a5c78236e401ec39024dd.pdf";